// Files served from public/downloads.
export const PROJECT_TEMPLATE_URL =
  "/downloads/templates/paxray-project-template.xlsx";

export function downloadProjectTemplate() {
  const link = document.createElement("a");
  link.href = PROJECT_TEMPLATE_URL;
  link.download = "";
  link.click();
}

// Sheet names in the project template, the importers preselect them.
export const TEMPLATE_SHEETS = {
  framework: "2. Process & Activity Structure",
  teamUsers: "3. Client Rollout Users",
};
